
const loadAnswerDocsGraphUi = () => import('answer-docs-graph-ui').then(module => module.default);
export const docs_graph = loadAnswerDocsGraphUi